import { api } from "../client";
import {
  DocumentOfferExtraFields,
  DocumentOfferFields,
  PartialDocumentOfferExtraFields,
  PartialDocumentOfferFields,
} from "../schema/DocumentOffer";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<DocumentOfferFields, DocumentOfferExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialDocumentOfferFields,
  PartialDocumentOfferExtraFields
>;

export const getDocumentOffers = async (config?: ApiRequestConfig) => {
  return api.get<DocumentOfferFields, DocumentOfferExtraFields>(
    "document_offers",
    config
  );
};
export const getDocumentOffer = (id: number, config?: ApiRequestConfig) => {
  return api.get<DocumentOfferFields, DocumentOfferExtraFields>(
    `document_offers/${id}`,
    config
  );
};

export const createDocumentOffer = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialDocumentOfferFields,
    PartialDocumentOfferExtraFields
  >("document_offers", config);
};
export const updateDocumentOffer = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialDocumentOfferFields,
    PartialDocumentOfferExtraFields
  >(`document_offers/${id}`, config);
};
export const deleteDocumentOffer = (id: number) => {
  return api.remove<DocumentOfferFields, DocumentOfferExtraFields>(
    `document_offers/${id}`
  );
};
